export type CertificateUnlockSource =
	| "learning_plan"
	| "transcript"
	| "course_certificate"
	| "workshop_certificate"
	| "certification_certificate"
	| "passed_certification_card";

/**
 * Builds the become-a-member page URL for certificate/transcript unlock CTAs.
 * Prefer this over opening the BAM modal so users land on a dedicated page.
 */
export const getCertificateUnlockHref = (
	source: CertificateUnlockSource,
): string => `/become-a-member?from=${source}`;

/**
 * Honest labels: members see View/Download; non-members see unlock copy
 * instead of a button that opens pricing under a certificate label.
 */
export const getCertificateUnlockLabel = ({
	hasAccess,
	action,
	noun,
}: {
	hasAccess: boolean;
	action: "view" | "download";
	noun?: string;
}): string => {
	if (!hasAccess) {
		return "Unlock with membership";
	}

	const verb = action === "view" ? "View" : "Download";
	return noun ? `${verb} ${noun}` : verb;
};
